import React from "react"
import { useBuilderState } from "app/forms/builder/builder-context"
import { useStyles } from "app/forms/data/use-styles"

export function Price({ price, className }) {
  const builderState = useBuilderState()
  const styles = useStyles()

  const handleClick = () => {
    builderState.setActiveElement("price")
  }

  if (price.installments) {
    return (
      <button
        onClick={handleClick}
        style={styles.forElement("price")}
        className={className}
      >
        {price.formatted_installments_duration}
        <div className="text-xl text-gray-500 mb-4 text-left">
          {price.formatted}
        </div>
      </button>
    )
  }

  return (
    <button
      onClick={handleClick}
      style={styles.forElement("price")}
      className={className}
    >
      {price.formatted ? price.formatted : price}
    </button>
  )
}
